import type { FC } from 'react';

interface BrandIconProps {
  name: string;
  className?: string;
}

const icons: Record<string, FC<{ className?: string }>> = {
  WhatsApp: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  ),
  Telegram: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#0088cc">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
    </svg>
  ),
  Instagram: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="ig" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#feda75" />
          <stop offset="50%" stopColor="#d62976" />
          <stop offset="100%" stopColor="#4f5bd5" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#ig)" />
      <path d="M12 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm0 8a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zM18 6.5a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z" fill="#fff" />
      <circle cx="12" cy="12" r="4.4" stroke="#fff" strokeWidth="1.6" fill="none" />
    </svg>
  ),
  X: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#000">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  Messenger: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#0084FF">
      <path d="M12 0C5.373 0 0 4.975 0 11.115c0 3.47 1.72 6.56 4.415 8.568V24l4.915-2.705c1.39.387 2.86.595 4.37.595 6.627 0 12-4.975 12-11.115S18.627 0 12 0zm6.15 8.63l-4.18 6.63c-.26.41-.74.57-1.16.38l-3.36-1.89a.68.68 0 0 0-.58-.04l-3.13.97a.67.67 0 0 1-.78-.91l4.18-6.63c.26-.41.74-.57 1.16-.38l3.36 1.89a.68.68 0 0 0 .58.04l3.13-.97a.67.67 0 0 1 .78.91z" />
    </svg>
  ),
  ZuriChat: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#2563eb">
      <defs>
        <linearGradient id="zuri" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2563eb" />
          <stop offset="100%" stopColor="#1d4ed8" />
        </linearGradient>
      </defs>
      <rect width="24" height="24" rx="6" fill="url(#zuri)" />
      <path d="M7 8l2.5 2.5L17 5" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="17" cy="17" r="3" fill="#fff" opacity="0.3" />
    </svg>
  ),
  'Google Analytics': ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#E37400">
      <path d="M22.84 23.04l-6.96-12.14a1.5 1.5 0 0 0-2.6 0L8 18.2V1.5A1.5 1.5 0 0 0 6.5 0h-5A1.5 1.5 0 0 0 0 1.5v21A1.5 1.5 0 0 0 1.5 24h5c.42 0 .8-.17 1.07-.45l.02-.02a1.5 1.5 0 0 0 .41-1.03v-6.5l4.98 8.66a1.5 1.5 0 0 0 2.6 0l6.96-12.13a1.5 1.5 0 0 0-2.6-1.49z" />
    </svg>
  ),
  Gmail: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#EA4335">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
  LiveChat: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#8b5cf6">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    </svg>
  ),
  Email: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#6366f1">
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  ),
  Meta: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#1877F2">
      <rect width="24" height="24" rx="5" />
      <path d="M13.6 18v-6.2h2.1l.3-2.4H13.6V7.8c0-.7.2-1.2 1.2-1.2h1.3V4.5c-.6-.1-1.3-.1-1.9-.2-1.9 0-3.2 1.2-3.2 3.3v1.8H8.9v2.4h2.1V18h2.6z" fill="#fff" />
    </svg>
  ),
  GoogleCloud: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="gcp" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4285F4" />
          <stop offset="33%" stopColor="#EA4335" />
          <stop offset="66%" stopColor="#FBBC05" />
          <stop offset="100%" stopColor="#34A853" />
        </linearGradient>
      </defs>
      <path d="M12.2 4.6a7.4 7.4 0 0 0-6.9 4.7 1.5 1.5 0 0 0 .2 1.6l2.2 2.2c.3.3.7.3 1 0 .4-.3.4-.8.2-1.2a3.7 3.7 0 0 1 3.3-5.5 3.7 3.7 0 0 1 3.7 3.7 3.7 3.7 0 0 1-3.7 3.7H4.2c-.5 0-.9.4-.9.9v.1c0 .5.4.9.9.9h7.9a5.9 5.9 0 0 0 5.9-5.9 5.9 5.9 0 0 0-5.7-5.1z" fill="url(#gcp)" />
    </svg>
  ),
  LinkedIn: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#0A66C2">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.852 0-1.463.016-2.679 1.755-2.679 1.755 0 1.755-2.526 1.755-2.526v-6.797h3.554v5.569c0 2.287.016 5.716 3.037 5.716 3.037 1.852 0 3.037-1.852 3.037-1.852v-6.797zM3.569 20.452h3.554v-10.756H3.569v10.756zM5.346 6.605c1.137 0 2.057-.92 2.057-2.057 0-1.137-.92-2.057-2.057-2.057-1.137 0-2.057.92-2.057 2.057 0 1.137.92 2.057 2.057 2.057zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z" />
    </svg>
  ),
  YouTube: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#FF0000">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505a3.017 3.017 0 0 0-2.122-2.136C.982 4.76.982 12 4.76 12 4.76s11.018 0 12.502 1.414a3.016 3.016 0 0 0 2.122 2.136c1.872 1.415 9.377 1.415 9.377 1.415s7.505 0 9.377-.505a3.016 3.016 0 0 0 2.122-2.136c.982-1.254.982-12.502.982-12.502.982s-11.018 0-12.502-1.414zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  ),
  TikTok: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="#000000">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93v6.16c0 2.52-1.12 4.84-2.9 6.05-1.68 1.16-3.91 1.49-5.92.79-2.01-.7-3.57-2.39-4.16-4.4-.59-2.01-.23-4.23 1.06-5.94 1.3-1.71 3.38-2.76 5.63-2.76v4.1c-1.44-.16-2.87.57-3.61 1.85-.75 1.28-.6 2.88.37 4.03.97 1.15 2.58 1.61 4.03 1.19 1.45-.42 2.51-1.73 2.51-3.23V.02h1.31z" />
    </svg>
  ),
};

export default function BrandIcon({ name, className = 'h-8 w-8' }: BrandIconProps) {
  const Icon = icons[name] || icons.ZuriChat;
  return <Icon className={className} />;
}
